export const TEST_ID = 'onboardingLayout';
